<template>
  <b-container>
    <verification-result
      message="forgot.check.m"
      action="forgot.check.a"
      no-button
    >
      <template v-slot:icon><div class="icon check-email-icon"></div></template>
    </verification-result>
  </b-container>
</template>

<script>
// @ is an alias to /src
import VerificationResult from "@/components/verification/VerificationResult";

export default {
  name: "CheckEmail",
  components: { VerificationResult },
};
</script>

<style>
.check-email-icon {
  background-image: url(/check-email.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>

